import { render, staticRenderFns } from "./onlyWageHistory.vue?vue&type=template&id=022b3092&scoped=true&"
import script from "./onlyWageHistory.vue?vue&type=script&lang=js&"
export * from "./onlyWageHistory.vue?vue&type=script&lang=js&"
import style0 from "./onlyWageHistory.vue?vue&type=style&index=0&id=022b3092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b3092",
  null
  
)

export default component.exports